import React from 'react'
import * as S from "./tabsDecor_style"
import FotoObraDecor from "../../imagens/foto10obra.jpg"
import FotoCores from "../../imagens/cores1.png"

export default function tabsDecor() {
    return (
        <>
            <S.SectionGlobal>
                <S.SectionTabela>
                    <S.DivTabelaTitulo>
                        <p>Tipo</p>
                        <p>Medidas</p>
                        <p>Peças por m²</p>
                        <p>Peso</p>
                        <p>MPA</p>
                    </S.DivTabelaTitulo>
                    <S.DivTabelaConteudo>
                        <p>Decor</p>
                        <p>13,5 x 06 x 22</p>
                        <p>41 peças</p>
                        <p>2,1 kg</p>
                        <p>20 a 35</p>
                    </S.DivTabelaConteudo>
                    <S.DivAplicacoes>
                        <p>Aplicações recomendadas:</p>
                        <ul>
                            <li>Pedestres (6cm de espessura)</li>
                            <li>Veículos leves (6cm de espessura)</li>
                            <li>Caminhôes de até três eixos (6cm a 8cm de espessura)</li>
                        </ul>
                    </S.DivAplicacoes>
                    <S.ImgCores src={FotoCores} alt="cores" />
                </S.SectionTabela>
                    <S.ImgDecor src={FotoObraDecor} alt="obra" />
            </S.SectionGlobal>
        </>
    )
}